import type { EntryPoint, EntryPointComponent } from 'react-relay';
import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import type { EditCustomTemplateQueryParamModalRuntimeProps } from './EditCustomTemplateQueryParamModal.entrypoint.types.tsx';
import editCustomTemplateQueryParamModalQueryParameters from './__generated__/EditCustomTemplateQueryParamModalQuery$parameters';
import type { EditCustomTemplateQueryParamModalQuery as TEditCustomTemplateQueryParamModalQuery } from './__generated__/EditCustomTemplateQueryParamModalQuery.graphql';

type QueryParams = {
	projectAri: string;
};

type EditCustomTemplateQueryParamModalEntryPointComponent = EntryPointComponent<
	{
		editCustomTemplateQuery: TEditCustomTemplateQueryParamModalQuery;
	},
	{},
	EditCustomTemplateQueryParamModalRuntimeProps,
	{}
>;

export const editCustomTemplateQueryParamEntryPoint: EntryPoint<
	EditCustomTemplateQueryParamModalEntryPointComponent,
	QueryParams
> = createEntryPoint({
	root: JSResourceForInteraction<EditCustomTemplateQueryParamModalEntryPointComponent>(
		/* webpackChunkName: "async-edit-custom-template-query-param-modal" */ './EditCustomTemplateQueryParamModal.tsx',
	),
	getPreloadProps: ({ projectAri }: QueryParams) => ({
		queries: {
			editCustomTemplateQuery: {
				parameters: editCustomTemplateQueryParamModalQueryParameters,
				variables: {
					projectAri,
				},
				options: {
					fetchPolicy: 'store-or-network' as const,
				},
			},
		},
	}),
});
